// state is not the application state, only the state this
// reducer is responsible for.
import {FETCH_LEADERBOARD_FOR_GAME, GAME_SELECTED} from "../constants/ActionTypes";

export default function (state = null, action) {

   switch (action.type) {
      case GAME_SELECTED:
         const newGameId = action.payload;
         if (!state) return null;

         // wipe out if gameId's don't match
         if (state.gameId !== newGameId) return null;

         return state;

      case FETCH_LEADERBOARD_FOR_GAME:
         const payload = action.payload;

         if (payload) {
            return payload;         // payload is of the form: { leaderboard: leaderboard, gameId: game.id }
         } else {
            return state;
         }
      default:
         return state;
   }
}


// WEBPACK FOOTER //
// ./src/reducers/reducer_leaderboard.js